// ABOUTME: Small colored dot indicating that a field has been overridden at the current scope.
// ABOUTME: Used in entity form labels to visually flag inherited-value overrides.
import React from 'react'

export const OverrideDot: React.FC = () => (
  <span className="inline-block size-1.5 rounded-full bg-primary shrink-0" aria-hidden="true" />
)
